/* eslint-disable max-len */
import 'jquery.dotdotdot';
import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class Truncate extends Component {
  /**
   * determine which text should be truncated
   */
  setupTruncate(query) {
    if (query.matches && this.truncateDesktop) {
      this.truncate();
    } else if (! query.matches && this.truncateMobile) {
      this.truncate();
    } else {
      this.element.innerHTML = this.originalWords;
      $(`#${this.element.id}`).css('height', 'auto');
      if (! this.toggleLoadMore) {
        $(this.loadMoreButton).hide();
      } else {
        $(this.toggleTextExpanded).show();
        $(this.toggleTextTruncated).hide();
        $(this.toggleBtnExpanded).show();
        $(this.toggleBtnTruncated).hide();
      }
    }
  }

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.truncateBreakpoint = this.utils.breakpoints.generateMedia('m', false);
    this.originalWords = this.element.innerHTML;
    this.loadMore = this.element.dataset.loadMoreTarget;
    this.loadMoreButton = document.querySelector(`[data-load-more-element="${this.loadMore}"]`);
    this.toggleTextExpanded = document.querySelector(this.elements.toggleTextExpanded);
    this.toggleTextTruncated = document.querySelector(this.elements.toggleTextTruncated);
    this.toggleBtnExpanded = document.querySelector(this.elements.toggleBtnExpanded);
    this.toggleBtnTruncated = document.querySelector(this.elements.toggleBtnTruncated);
    this.truncateMobile = this.element.hasAttribute('truncateMobile');
    this.truncateDesktop = this.element.hasAttribute('truncateDesktop');
    this.loadMoreClickListeners = this.loadMoreClickListeners.bind(this);
    if (null !== this.loadMoreButton) {
      this.toggleLoadMore = this.loadMoreButton.hasAttribute('loadmoreToggle');
    }

    if (this.loadMore && this.loadMoreButton) {
      this.loadMoreClickListeners();
    } else if (this.loadMoreButton) {
      // Hide the button if we don't start.
      $(this.loadMoreButton).hide();
    }

    // hide load more if text shorter than div
    if (undefined !== $(`#${this.element.id}`)[0]) {
      if (
        $(`#${this.element.id}`)[0].scrollHeight
        <= $(`#${this.element.id}`).outerHeight(true)
      ) {
        $(`#${this.element.id}`).css('height', 'auto');
        $(this.loadMoreButton).hide();
      } else {
        this.setupTruncate = this.setupTruncate.bind(this);
        this.setupTruncate(this.truncateBreakpoint);
        this.truncateBreakpoint.addListener(this.setupTruncate);
      }
    }
  }

  truncate() {
    $(`#${this.element.id}`).dotdotdot();
    $(this.loadMoreButton).show();
    $(this.toggleTextExpanded).hide();
    $(this.toggleTextTruncated).show();
    $(this.toggleBtnExpanded).hide();
    $(this.toggleBtnTruncated).show();
  }

  expand() {
    $(`#${this.element.id}`)
      .trigger('originalContent', (content) => {
        $(`#${this.element.id}`)
          .empty()
          .append(content)
          .removeClass('is-truncated')
          .css('height', 'auto');
        if (! this.toggleLoadMore) {
          $(this.loadMoreButton).hide();
        } else {
          $(this.toggleTextExpanded).show();
          $(this.toggleTextTruncated).hide();
          $(this.toggleBtnExpanded).show();
          $(this.toggleBtnTruncated).hide();
        }
      });
  }

  /**
   * Jump to an element using the element ID
   * @param object ele element to jump to
   */
  // eslint-disable-next-line class-methods-use-this
  jump(ele) {
    const top = document.getElementById(ele).offsetTop;
    window.scrollTo(0, top);
  }

  /**
   * expand text where a load more button
   */
  loadMoreClickListeners() {
    if (null != this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.toggleLoadMore
          && ! this.element.classList.contains('is-truncated')) {
          this.element.classList.add('is-truncated');
          this.truncate();
          this.jump(this.element.id);
        } else {
          this.expand();
        }
      });
    }
  }
}
